
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M20 3h-1V2a1 1 0 00-2 0v1H7V2a1 1 0 10-2 0v1H4a2.006 2.006 0 00-2 2v16a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V5a2.006 2.006 0 00-2-2zm-1 18H5a1 1 0 01-1-1V8h16v12a1 1 0 01-1 1z"}})])
          )
        }
      }
    